<template>
  <div class="page flex-col">
    <div class="wrap1 flex-col">
      <img
        class="img1"
        referrerpolicy="no-referrer"
        src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngad5f0d35d719a5e8e532d9026a1423ccdd763d660c0787a153fa85932c23e026"
      />
    </div>
    <div class="wrap2 flex-col" v-if="type === 2 || type === 1">
      <div class="layer1 flex-row justify-between">
        <div class="outer1 flex-col"></div>
        <div class="outer2 flex-col">
          <img
            class="label1"
            style="cursor: pointer"
            @click="type = 3"
            referrerpolicy="no-referrer"
            src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng48f542be5d6e48cfd40b77b41d22ef34c77d0be6a5f6d438441e685063b26f69"
          />
        </div>
      </div>
      <div v-if="type === 1" class="layer2 flex-row">
        <el-input placeholder="请输入账号"></el-input>
      </div>
      <div v-if="type === 1" class="layer3 flex-row">
        <el-input show-password placeholder="请输入密码"></el-input>
      </div>
      <div v-if="type === 2" class="layer2 flex-row">
        <el-input v-model="form.mobile" placeholder="请输入手机号"></el-input>
      </div>
      <div v-if="type === 2" class="layer3 flex-row" style="position: relative">
        <el-input v-model="form.smsCode" placeholder="请输入验证码"></el-input>
        <el-button
          style="position: absolute; right: 10px; top: 5px"
          @click="getSMS"
          type="text"
          >{{ text }}</el-button
        >
      </div>
      <div class="layer4 flex-row align-center">
        <el-checkbox v-model="checked">升级为会员</el-checkbox>
        <span class="info4">忘记密码</span>
      </div>
      <div class="layer5 flex-row">
        <button class="section1 flex-col" @click="onClick_1">
          <span class="word7">登录</span>
        </button>
      </div>
      <div class="layer6 flex-row justify-between">
        <span v-if="type === 1" @click="type = 2" class="info5"
          >手机号登录</span
        >
        <span v-if="type === 2" @click="type = 1" class="info5">账号登录</span>
        <span class="word8">立即注册</span>
      </div>
    </div>

    <div class="wrap2 flex-col align-center" style="font-size: 20px" v-else>
      <div
        class="flex-row justify-between align-center"
        style="
          padding-top: 30px;
          padding-bottom: 20px;
          padding-left: 30px;
          padding-right: 30px;
          width: 100%;
        "
      >
        <i
          style="cursor: pointer"
          @click="type = 2"
          class="el-icon-arrow-left"
        ></i>
        <i style="cursor: pointer" @click="type = 2" class="el-icon-close"></i>
      </div>
      <span style="margin-bottom: 15px; font-size: 18px">微信登录</span>
      <vue-qr
        text="的期望的期望的期望带我去打网球的委屈委屈带我去我去单位请问带我去权威的去的期望的期望带我去打网球的委屈委屈带我去我去单位请问带我去权威的去的期望的期望带我去打网球的委屈委屈带我去我去单位请问带我去权威的去的期望的期望带我去打网球的委屈委去我去单位请问带我去权威的去"
        logoMargin="5"
        logoScale="0.12"
        :logoSrc="logoSrc"
        :size="200"
        :margin="0"
      ></vue-qr>
      <span style="margin-top: 20px; margin-bottom: 20px; font-size: 18px"
        >使用微信扫码登录</span
      >
      <div style="color: #bcbcbc; font-size: 14px">
        没有账号？<span style="color: #aa1d1f">立即注册</span>
      </div>
    </div>
  </div>
</template>
<script>
import eventBus from '@/utils/eventBus.js'
import VueQr from "vue-qr"
import {
  read,
  smsCode,
  smsLogin,
  bookInfo,
  bookPage
} from '@/api/api'
export default {
  components: {
    VueQr
  },
  data () {
    return {
      checked: true,
      logoSrc: '',
      text: '获取验证码',
      form: {
        mobile: '',
        smsCode: '',
      },
      type: 2,
      constants: {},
    }
  },
  mounted () {
    this.logoSrc = require('@/assets/wx.png')
  },
  methods: {
    getSMS () {
      if (!this.form.mobile) {
        this.$message.error('请输入手机号')
        return
      }
      if (!(/^[1][35789][0-9]{9}$/.test(this.form.mobile))) {
        this.$message.error('请输入正确手机号')
        return
      }

      if (this.text === '获取验证码') {
        smsCode({
          mobile: this.form.mobile,
          scene: 'LOGIN'
        }).then(res => {
          let num = 4
          const times = setInterval(() => {
            num--
            if (num === 0) {
              clearInterval(times)
              this.text = `获取验证码`
            } else {
              this.text = `重新获取(${num}s)`
            }
          }, 1000)
          this.form.uuid = res.uuid
          this.form.smsCode = res.smsCode
        })
      }
    },
    onClick_1 () {
      if (!this.form.mobile) {
        this.$message.error('请输入手机号')
        return
      }
      if (!(/^[1][35789][0-9]{9}$/.test(this.form.mobile))) {
        this.$message.error('请输入正确手机号')
        return
      }
      if (!this.form.smsCode) {
        this.$message.error('请输入验证码')
        return
      }
      smsLogin(this.form).then(res => {
        if (res.code === 200) {
          localStorage.setItem('token', 'Bearer ' + res.token)
          eventBus.$emit('outLogin', 1)
          this.$message.success('登录成功')

          this.$router.replace({
            path: this.$route.query.forword ? this.$route.query.forword : '/'
          })
        }
      })
    },
  },
};
</script>
<style scoped lang="less">
/deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
/deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #000000;
  border-color: #000000;
}

/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #000000;
}

/deep/ .el-checkbox.is-bordered.is-checked {
  border-color: #000000;
}

/deep/ .el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #000000;
}

/deep/ .el-input__inner {
  border-radius: 26px;
  height: 52px;
  border: 1px solid #dddddd;
}

/* 谷歌 */
/deep/ .el-input__inner::-webkit-input-placeholder {
  color: #454545;
  font-weight: 600;
}

/* 火狐 */
/deep/ .el-input__inner:-moz-placeholder {
  color: #454545;
  font-weight: 600;
}

/*ie*/
/deep/ .el-input__inner:-ms-input-placeholder {
  color: #454545;
  font-weight: 600;
}

/* //获取焦点时的颜色 */
/deep/ .el-input__inner:focus::-webkit-input-placeholder {
  color: #454545;
  font-weight: 600;
}

/deep/ .el-input__inner:focus::-moz-input-placeholder {
  color: #454545;
  font-weight: 600;
}

/deep/ .el-input__inner:focus::-ms-input-placeholder {
  color: #454545;
  font-weight: 600;
}

html {
  font-size: 37.5px;
}

.page {
  width: 100%;
  position: relative;
  height: 24.187rem;
  background-color: rgba(245, 245, 245, 1);
  overflow: hidden;
  margin: 0 auto;
}

.wrap1 {
  height: 24.187rem;
}

.mod1 {
  height: 2.08rem;
  background-color: rgba(255, 255, 255, 1);
  padding: 0.507rem 0 0 2.987rem;
}

.group1 {
  width: 32.214rem;
  height: 1.307rem;
}

.bd1 {
  width: 4.534rem;
  height: 1.307rem;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng4763fecae4f3dbd33fedecbd4a2e0fc03f75b4cd8e9d4e000fe793b5c88589d4)
    0.187rem 0rem no-repeat;
  background-size: 4.347rem 1.334rem;
}

.bd2 {
  height: 0.827rem;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng6bf1dc9e05e2fcfc42219f92ddbe5dd7fc853ba61295d528ec2d1b0b07003555)
    100% no-repeat;
  width: 3.467rem;
  margin: 0.134rem 0 0 2.8rem;
  padding: 0.16rem 0 0 1.28rem;
}

.word1 {
  width: 0.88rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(170, 29, 31, 1);
  font-size: 0.373rem;
  font-family: PingFangTC-Semibold;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
}

.word2 {
  width: 1.734rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 1);
  font-size: 0.373rem;
  font-family: PingFangTC-Semibold;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
  margin: 0.294rem 0 0 1.494rem;
}

.info1 {
  width: 1.734rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 1);
  font-size: 0.373rem;
  font-family: PingFangTC-Semibold;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
  margin: 0.294rem 0 0 1.494rem;
}

.word3 {
  width: 1.494rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 1);
  font-size: 0.373rem;
  font-family: PingFangTC-Semibold;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
  margin: 0.294rem 0 0 1.494rem;
}

.txt1 {
  width: 1.494rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 1);
  font-size: 0.373rem;
  font-family: PingFangTC-Semibold;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
  margin: 0.294rem 0 0 1.52rem;
}

.bd3 {
  width: 0.427rem;
  height: 0.587rem;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng5618ba96d6e45c5af5d14cae1dcfca8615fc726c6816559d10f2f2d325c1d304)
    100% no-repeat;
  margin: 0.24rem 0 0 6.214rem;
}

.word4 {
  width: 0.747rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 1);
  font-size: 0.373rem;
  font-family: PingFangSC-Medium;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
  margin: 0.294rem 0 0 0.214rem;
}

.bd4 {
  width: 0.027rem;
  height: 0.427rem;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng292e16e315659a9700abfa430c040d1419bc4573dc009e320d08121fccd7eb1f)
    0rem 0rem no-repeat;
  background-size: 0.027rem 0.454rem;
  margin: 0.347rem 0 0 0.294rem;
}

.txt2 {
  width: 0.747rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 1);
  font-size: 0.373rem;
  font-family: PingFangSC-Medium;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
  margin: 0.294rem 0 0 0.294rem;
}

.img1 {
  width: 38.4rem;
  height: 11.44rem;
  margin-top: 8.534rem;
}

.mod2 {
  width: 38.4rem;
  height: 0.134rem;
  background-color: rgba(170, 29, 31, 1);
  margin: 0;
}

.mod3 {
  z-index: 4;
  height: 2rem;
  overflow: hidden;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng2dc70e2dd957c588ff9bfdb344f8935d1e22f4b76f2bdd7091a344d1f294119c)
    100% no-repeat;
  width: 38.4rem;
  position: relative;
  padding: 0.747rem 0 0 16.187rem;
  margin: 0;
}

.word5 {
  z-index: 7;
  position: static;
  left: 16.187rem;
  top: 22.934rem;
  width: 6.054rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.373rem;
  font-family: PingFangTC-Regular;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
}

.pic1 {
  z-index: 5;
  position: absolute;
  left: 0;
  top: 0;
  width: 38.4rem;
  height: 2rem;
}

.wrap2 {
  z-index: 10;
  height: 12.56rem;
  border-radius: 29px;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0px 9px 17px 0px rgba(188, 188, 188, 0.5);
  width: 12.56rem;
  position: absolute;
  /* left: 12.907rem; */
  left: 50%;
  transform: translateX(-50%);
  top: 5.334rem;
}

.layer1 {
  width: 6.347rem;
  height: 2.187rem;
  margin: 0.4rem 0 0 5.627rem;
}

.outer1 {
  width: 1.44rem;
  height: 1.44rem;
  border-radius: 50%;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng2e465c07bb60ef7f9fc1c58e5337926353177a845e6125318e228887717d543b)
    100% no-repeat;
  margin-top: 0.747rem;
}

.outer2 {
  z-index: 33;
  position: relative;
  width: 1.12rem;
  height: 1.227rem;
  overflow: hidden;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng5105f9b9fcb574ec46cc5d10cfa11e304b87d46c1a806fe68046858499c04542)
    0rem -0.027rem no-repeat;
  background-size: 1.12rem 1.227rem;
}

.label1 {
  z-index: 34;
  position: absolute;
  left: 0;
  top: -0.026rem;
  width: 1.12rem;
  height: 1.227rem;
}

.layer2 {
  width: 9.147rem;
  height: 1.387rem;
  margin: 1.04rem 0 0 1.707rem;
}

.main1 {
  height: 1.387rem;
  border-radius: 26px;
  border: 1px solid rgba(221, 221, 221, 1);
  background-color: rgba(255, 255, 255, 1);
  padding-left: 0.72rem;
  width: 9.147rem;
}

.info2 {
  width: 1.867rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(69, 69, 69, 1);
  font-size: 0.373rem;
  font-family: PingFangSC-Semibold;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
}

.layer3 {
  width: 9.147rem;
  height: 1.387rem;
  margin: 0.694rem 0 0 1.707rem;
}

.bd5 {
  height: 1.387rem;
  border-radius: 26px;
  border: 1px solid rgba(221, 221, 221, 1);
  background-color: rgba(255, 255, 255, 1);
  padding-left: 0.72rem;
  width: 9.147rem;
}

.info3 {
  width: 1.867rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(69, 69, 69, 1);
  font-size: 0.373rem;
  font-family: PingFangSC-Semibold;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
}

.layer4 {
  width: 8.64rem;
  height: 0.587rem;
  margin: 0.587rem 0 0 1.84rem;
}

.label2 {
  width: 0.587rem;
  height: 0.587rem;
}

.word6 {
  width: 1.6rem;
  height: 0.454rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 1);
  font-size: 0.32rem;
  white-space: nowrap;
  line-height: 0.454rem;
  text-align: left;
  margin: 0.08rem 0 0 0.187rem;
}

.info4 {
  cursor: pointer;
  display: block;
  overflow-wrap: break-word;
  color: rgba(166, 166, 166, 1);
  font-size: 0.32rem;
  white-space: nowrap;
  text-align: left;
  margin: 0rem 0 0 4.987rem;
}

.layer5 {
  width: 9.147rem;
  height: 1.52rem;
  margin: 0.694rem 0 0 1.707rem;
}

.section1 {
  height: 1.52rem;
  border-radius: 28.5px 28.5px 28.5px 28.5px;
  background-color: rgba(170, 29, 31, 1);
  width: 9.147rem;
  padding: 0.48rem 0 0 4.16rem;
}

.word7 {
  width: 0.854rem;
  height: 0.587rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 0.426rem;
  font-family: PingFangSC-Semibold;
  white-space: nowrap;
  line-height: 0.587rem;
  text-align: left;
}

.layer6 {
  width: 8.827rem;
  height: 0.454rem;
  margin: 0.48rem 0 1.147rem 1.707rem;
}

.info5 {
  cursor: pointer;
  width: 1.6rem;
  height: 0.454rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(166, 166, 166, 1);
  font-size: 0.32rem;
  white-space: nowrap;
  line-height: 0.454rem;
  text-align: left;
}

.word8 {
  width: 1.28rem;
  height: 0.454rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(170, 29, 31, 1);
  font-size: 0.32rem;
  white-space: nowrap;
  line-height: 0.454rem;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/pages/login.vue